import React, { useContext } from 'react'
import $ from 'jquery'
import { Link, Routes } from 'react-router-dom';
import RoutesContext from './RoutesContext';

function Header() {
    const routes_context = useContext(RoutesContext);

    let menu_active = false;
    function hamburger_menu_button(event){
        const button = $('.hamburger_menu_button_wrapper');
        const hamburger_menu= $('.hamburger_menu');
        if(menu_active){
            button.removeClass('open');
            hamburger_menu.removeClass('menu_open');
            menu_active = false;
        } else {
            button.addClass('open');
            hamburger_menu.addClass('menu_open');
            menu_active = true;
        }
    }

  return (
    <>
        <header>
            <div className="header_wrapper">
                <div className="header_top_section">
                    <div className="header_logo_1">
                        <img src={require("./static/img/logo3.jpg")} alt="logo_image" />
                        <h1>"Maryawtoulag" <br />
                            ÖNÜMÇILIK BIRLEŞIGI</h1>
                    </div>
                    <div className="header_logo_2">
                        <h1>HALKYŇ ARKADAGLY <br />
                            ZAMANASY</h1>
                        <img src={require("./static/img/logo2022.png")} alt="logo_image_2" />
                    </div>
                </div>
            </div>

        </header>
        
        <nav className="header_bottom_section">
            <div className="header_bottom_wrapper">
                <div className="button_animation"><Link to={routes_context.home_page}>Baş sahypa</Link></div>
                <div className="button_animation"><Link to={routes_context.about_us}>Biz hakda</Link></div>
                <div className="button_animation"><Link to={routes_context.news}>Täzelikler</Link></div>
                <div className="button_animation"><Link to={routes_context.contacts}>Salgymyz</Link></div>
                <div className="button_animation"><Link to={routes_context.orders}>Sargytlar</Link></div>
                <div className="flags">
                    <a href="#"><img src={require("./static/img/tm.jpg")} alt="turkmen" /></a>
                    <a href="#"><img src={require("./static/img/rus.jpg")} alt="russian" /></a>
                </div>
            </div>

            <div className="header_bottom_wrapper_hamburger">
                <div className="hamburger_menu_button_wrapper" onClick={hamburger_menu_button}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className="hamburger_menu">
                    <div className="hamburger_menu_inner_wrapper">
                        <div className="button_animation"><a href="index.html">Baş sahypa</a></div>
                        <div className="button_animation"><a href="about_us.html">Biz hakda</a></div>
                        <div className="button_animation"><a href="news.html">Täzelikler</a></div>
                        <div className="button_animation"><a href="contacts.html">Salgymyz</a></div>
                        <div className="button_animation"><a href="orders.html">Sargytlar</a></div>
                        <div className="flags">
                            <a href="#"><img src={require("./static/img/tm.jpg")} alt="turkmen" /></a>
                            <a href="#"><img src={require("./static/img/rus.jpg")} alt="russian" /></a>
                        </div>
                    </div>
                </div>
            </div>

        </nav>
    </>
  )
}

export default Header